<template lang="pug">
#visaoGeralFazenda
    BaseHeader(
            titulo='Visão Geral Fazenda'
            :voltarPara='true'
        )
    
    .view-container.m-top
        CardDadosGeralFazenda(
            :dadosFazenda='dadosVisaoFazenda'
        )
    .filtros
        .filtro-busca
            FiltroRastreabilidade(
                textoPlaceHolder='Busque pelo número do documento'
                @atualizar-filtro='atualizarFiltro'
            )
        .filtro-data
            el-date-picker(
                v-model="filtroData",
                placement='bottom-start',
                type="daterange",
                placeholder='Data',
                start-placeholder="Data de início",
                end-placeholder="Data do fim",
                format='dd/MM/yyyy'
            )

    .documentosCabecalho
        h2(style='font-weight: bold; padding-bottom: 10px;') Listagem de documentos
        .bloco-tabs
            el-tabs(type="border-card" @tab-click='handleTabClick')
                el-tab-pane(label="Notas fiscais")
                    TabelaNotaFiscal(
                        :mostrarTitulo='false'
                        :mostrarAcoesPadrao='false'
                        :mostrarAcoesVisaoFazenda='true'
                        :mostrarCertificada='false'
                        v-loading='buscandoNotaFiscal',
                        :dadosTabela='dadosTabelaNotaFiscal',
                        :paginacao='paginacaoNotaFiscal',
                        @atualizar-pagina='atualizarPagina',
                        @atualizar-tabela='buscarNotaFiscal'
                    )
                el-tab-pane(label="Lote de produção")
                    TabelaLoteDeProducao(
                        :mostrarTitulo='false'
                        :mostrarAcoesPadrao='false'
                        v-loading='buscandoLoteDeProducao',
                        :dadosTabela='dadosTabelaLoteProducao',
                        :paginacao='paginacaoProducao',
                        tipo='SOCIOAMBIENTAL',
                        @atualizar-pagina='atualizarPagina',
                        @atualizar-tabela='buscarLoteDeProducao'
                    )
                el-tab-pane(label="Nota de pesagem")
                    TabelaNotaDePesagem(
                        :mostrarTitulo='false'
                        :mostrarColuna='false'
                        :mostrarAcoesPadrao='false'
                        v-loading='buscandoNotaDePesagem',
                        :dadosTabela='dadosTabelaPesagem',
                        :paginacao='paginacaoPesagem',
                        @atualizar-pagina='atualizarPagina',
                        @atualizar-tabela='buscarNotaDePesagem'
                    )
                el-tab-pane(label="Ordem de corte")
                    TabelaOrdemDeCorte(
                        :mostrarTitulo='false'
                        :mostrarAcoesPadrao='false'
                        :mostrarColunaCertificada='false'
                        v-loading='buscandoOrdemDeCorte',
                        :dadosTabela='dadosTabelaOrdemCorte',
                        :paginacao='paginacaoOrdemCorte',
                        @atualizar-pagina='atualizarPagina',
                        @atualizar-tabela='buscarOrdensCorte'
                    )

    Footer
</template>

<script>
import BaseHeader from '@/components/rastreabilidadeRaizen/visaoGeral/BaseHeaderVisaoGeral.vue';
import CardDadosGeralFazenda from '@/components/rastreabilidadeRaizen/visaoGeral/CardDadosGeralFazenda.vue';
import FiltroRastreabilidade from '@/components/rastreabilidadeRaizen/FiltroRastreabilidade';
import TabelaOrdemDeCorte from '@/components/rastreabilidadeRaizen/ordemDeCorte/TabelaOrdemDeCorte';
import TabelaNotaDePesagem from '@/components/rastreabilidadeRaizen/notaDePesagem/TabelaNotaDePesagem';
import TabelaLoteDeProducao from '@/components/rastreabilidadeRaizen/loteDeProducao/TabelaLoteDeProducao';
import TabelaNotaFiscal from '@/components/rastreabilidadeRaizen/notaFiscal/TabelaNotaFiscal';

import RastreabilidadeOrdemDeCorteService from '@/services/RastreabilidadeOrdemDeCorteService';
import RastreabilidadeNotaDePesagemService from '@/services/RastreabilidadeNotaDePesagemService';
import RastreabilidadeLoteDeProducaoService from '@/services/RastreabilidadeLoteDeProducaoService';
import RastreabilidadeNotaFiscalService from '@/services/RastreabilidadeNotaFiscalService';
import RastreabilidadeVisaoFazendaService from '@/services/RastreabilidadeVisaoFazendaService';

export default {
    name: 'VisaoGeralFazenda',
    components: {
        BaseHeader,
        CardDadosGeralFazenda,
        FiltroRastreabilidade,
        TabelaOrdemDeCorte,
        TabelaNotaDePesagem,
        TabelaLoteDeProducao,
        TabelaNotaFiscal
    },

    props: {
        breadcrumb: {
            type: Array,
            default: () => []
        }
    },
    async mounted() {

    },
    computed: {
        usuario() {
            return this.$store.state.usuarioLogado;
        }
    },
    data() {
        return {
            codigoFazenda: this.$route.params.codigoFazenda,
            showModalSelecionarTerritorios: false,
            showModalConfirmarTerritorios: false,
            territoriosSelecionados: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                idsUsuarios: [],
                situacao: null,
                dataCadastroInicio: '',
                dataCadastroFim: ''
            },
            filtroData: '',
            totalCompartilhamentoDados: 0,
            compartilhamentoDados: [],
            idCompartilhamentoDados: null,
            rowInfo: null,
            showModalInsercaoResultados: false,
            usuariosBuffer: {},
            buscandoOrdemDeCorte: false,
            buscandoNotaDePesagem: false,
            buscandoLoteDeProducao: false,
            buscandoNotaFiscal: false,
            buscandoDadosFazenda: false,
            dadosVisaoFazenda: {},
            paginacaoNotaFiscal: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            },
            paginacaoProducao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            },
            paginacaoPesagem: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            },
            paginacaoOrdemCorte: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            },
            numeroDocumentoPesquisa: '000000039-1',
            dataInicioPesquisa: '2021-05-01 00:00:00',
            dataFimPesquisa: '2021-10-01 00:00:00',
            dadosTabelaNotaFiscal: [],
            dadosTabelaLoteProducao: [],
            dadosTabelaPesagem: [],
            dadosTabelaOrdemCorte: [],
            ordemCorteActive: false,
            notaPesagemActive: false,
            loteProducaoActive: false,
            notaFiscalActive: false,
            abaAtiva: '0'
        };
    },
    created() {
        this.buscarNotaFiscal(0);
        this.buscarLoteDeProducao(0);
        this.buscarNotaDePesagem(0);
        this.buscarOrdensCorte(0);
        this.buscarDadosFazenda();
    },
    methods: {
        async buscarOrdensCorte(pagina) {
            this.paginacaoOrdemCorte.pagina = pagina;
            this.buscandoOrdemDeCorte = true;
            await RastreabilidadeOrdemDeCorteService.buscarPorFazenda(
                this.codigoFazenda,
                this.paginacaoOrdemCorte
            ).then(({ data }) => {
                this.dadosTabelaOrdemCorte = data.itens;
                this.paginacaoOrdemCorte = data.paginacao;
                this.paginacaoOrdemCorte.pagina += 1;
                this.buscandoOrdemDeCorte = false;
            });
        },
        
        async buscarNotaDePesagem(pagina) {
                this.buscandoNotaDePesagem = true;
                this.paginacaoPesagem.pagina = pagina;
                await RastreabilidadeNotaDePesagemService.buscarPorFazenda(
                    this.codigoFazenda,
                    this.paginacaoPesagem
                ).then(({ data }) => {
                    this.dadosTabelaPesagem = data.itens;
                    this.paginacaoPesagem = data.paginacao;
                    this.paginacaoPesagem.pagina += 1;
                    this.buscandoNotaDePesagem = false;
                });

        },
        
        async buscarLoteDeProducao(pagina) {
                this.buscandoLoteDeProducao = true;
                this.paginacaoProducao.pagina = pagina;
                await RastreabilidadeLoteDeProducaoService.buscarPorFazenda(
                    this.codigoFazenda,
                    this.paginacaoProducao
                ).then(({ data }) => {
                    this.dadosTabelaLoteProducao = data.itens;
                    this.paginacaoProducao = data.paginacao;
                    this.paginacaoProducao.pagina += 1;
                    this.buscandoLoteDeProducao = false;
                });
        },

        async buscarNotaFiscal(pagina) {
            this.buscandoNotaFiscal = true;
            this.paginacaoNotaFiscal.pagina = pagina;
            await RastreabilidadeNotaFiscalService.buscarPorFazenda(
                this.codigoFazenda,
                this.paginacaoNotaFiscal
            ).then(({ data }) => {
                    this.dadosTabelaNotaFiscal = data.itens;
                    this.paginacaoNotaFiscal = data.paginacao;
                    this.paginacaoNotaFiscal.pagina += 1;
                    this.buscandoNotaFiscal = false;
            });
        },

        async buscarDadosFazenda() {
            this.buscandoDadosFazenda = true;
            await RastreabilidadeVisaoFazendaService.buscarPorFazenda(
                this.codigoFazenda
            ).then(({ data }) => {
                    this.dadosVisaoFazenda = data;
                    this.buscandoDadosFazenda = false;
            });
        },

        async buscarNotaFiscalPorNumeroEdata(pagina) {
            this.dataInicioPesquisa = this.filtroData[0] ? this.filtroData[0].toLocaleDateString('pt-BR') : '';
            this.dataFimPesquisa = this.filtroData[1] ? this.filtroData[1].toLocaleDateString('pt-BR') : '';
            
            this.buscandoNotaFiscal = true;
            this.paginacaoNotaFiscal.pagina = pagina;
            await RastreabilidadeNotaFiscalService.buscarPorNumeroEdata(
                this.codigoFazenda,
                this.numeroDocumentoPesquisa,
                this.dataInicioPesquisa,
                this.dataFimPesquisa,
                this.paginacaoNotaFiscal
            ).then(({ data }) => {
                    this.dadosTabelaNotaFiscal = data.itens;
                    this.paginacaoNotaFiscal = data.paginacao;
                    this.paginacaoNotaFiscal.pagina += 1;
                    this.buscandoNotaFiscal = false;
            });
        },

        async buscarNotaDePesagemPorNumeroEdata(pagina) {
            this.dataInicioPesquisa = this.filtroData[0] ? this.filtroData[0].toLocaleDateString('pt-BR') : '';
            this.dataFimPesquisa = this.filtroData[1] ? this.filtroData[1].toLocaleDateString('pt-BR') : '';
            
            this.buscandoNotaDePesagem = true;
            this.paginacaoPesagem.pagina = pagina;
            await RastreabilidadeNotaDePesagemService.buscarPorNumeroEdata(
                this.codigoFazenda,
                this.numeroDocumentoPesquisa,
                this.dataInicioPesquisa,
                this.dataFimPesquisa,
                this.paginacaoPesagem
            ).then(({ data }) => {
                    this.dadosTabelaPesagem = data.itens;
                    this.paginacaoPesagem = data.paginacao;
                    this.paginacaoPesagem.pagina += 1;
                    this.buscandoNotaDePesagem = false;
            });
        },

        async buscarOrdemCortePorNumeroEdata(pagina) {
            this.dataInicioPesquisa = this.filtroData[0] ? this.filtroData[0].toLocaleDateString('pt-BR') : '';
            this.dataFimPesquisa = this.filtroData[1] ? this.filtroData[1].toLocaleDateString('pt-BR') : '';
            
            this.buscandoOrdemDeCorte = true;
            this.paginacaoOrdemCorte.pagina = pagina;
            await RastreabilidadeOrdemDeCorteService.buscarPorNumeroEdata(
                this.codigoFazenda,
                this.numeroDocumentoPesquisa,
                this.dataInicioPesquisa,
                this.dataFimPesquisa,
                this.paginacaoOrdemCorte
            ).then(({ data }) => {
                    this.dadosTabelaOrdemCorte = data.itens;
                    this.paginacaoOrdemCorte = data.paginacao;
                    this.paginacaoOrdemCorte.pagina += 1;
                    this.buscandoOrdemDeCorte = false;
            });
        },
        
        async buscarLoteProducaoPorNumeroEdata(pagina) {
            this.dataInicioPesquisa = this.filtroData[0] ? this.filtroData[0].toLocaleDateString('pt-BR') : '';
            this.dataFimPesquisa = this.filtroData[1] ? this.filtroData[1].toLocaleDateString('pt-BR') : '';
            
            this.buscandoLoteDeProducao = true;
            this.paginacaoProducao.pagina = pagina;
            await RastreabilidadeLoteDeProducaoService.buscarPorNumeroEdata(
                this.codigoFazenda,
                this.numeroDocumentoPesquisa,
                this.dataInicioPesquisa,
                this.dataFimPesquisa,
                this.paginacaoProducao
            ).then(({ data }) => {
                    this.dadosTabelaLoteProducao = data.itens;
                    this.paginacaoProducao = data.paginacao;
                    this.paginacaoProducao.pagina += 1;
                    this.buscandoLoteDeProducao = false;
            });
        },

        handleTabClick(tab) {
            this.abaAtiva = tab.paneName;
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;
        },

        voltar() {
            this.changeShowModalConfirmarTerritorios();
        },

        handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
        },
        
        goToOrdemDeCorte() {
            this.$router.push({ name: 'OrdemDeCorte' });
        },

        atualizarPagina(pagina) {
            if (this.ordemCorteActive) {
                this.buscarOrdensCorte(pagina);
            } else if (this.notaPesagemActive) {
                this.buscarNotaDePesagem(pagina);
            } else if (this.loteProducaoActive) {
                this.buscarLoteDeProducao(pagina);
            } else {
                this.buscarNotaFiscal(pagina);
            }
        },

        alterarJanelaTabelas(tabelaDestino) {
            this.desativaRestanteJanelaTabelas(tabelaDestino);
          
            if (tabelaDestino === 'ordemCorte') {
                this.ordemCorteActive = true;
                this.buscarOrdensCorte(0);
            } else if (tabelaDestino === 'notaPesagem') {
                this.notaPesagemActive = true;
                this.buscarNotaDePesagem(0);
            } else if (tabelaDestino === 'loteProducao') {
                this.loteProducaoActive = true;
                this.buscarLoteDeProducao(0);
            } else {
                this.notaFiscalActive = true;
                this.buscarNotaFiscal(0);
            }
        },
        desativaRestanteJanelaTabelas(tabelaDestino) {
            if (tabelaDestino !== 'ordemCorte') {
                this.ordemCorteActive = false;
            }
            if (tabelaDestino !== 'notaPesagem') {
                this.notaPesagemActive = false;
            }
            if (tabelaDestino !== 'loteProducao') {
                this.loteProducaoActive = false;
            }
            if (tabelaDestino !== 'notaFiscal') {
                this.notaFiscalActive = false;
            }
        },

        atualizarFiltro(dados) {
            this.numeroDocumentoPesquisa = dados;
            switch (this.abaAtiva) {
                case '0':
                    this.buscarNotaFiscalPorNumeroEdata(0);
                    break;
                case '1':
                    this.buscarLoteProducaoPorNumeroEdata(0);
                    break;
                case '2':
                    this.buscarNotaDePesagemPorNumeroEdata(0);
                    break;
                case '3':
                    this.buscarOrdemCortePorNumeroEdata(0);
                    break;
                default:
                    break;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#visaoGeralFazenda {

    .compart-btn {
        justify-content: flex-end;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .m-top {
        margin-top: 25px;
    }

    .filtros{
        margin: 0px;
        width:100%;
        display:flex;
        align-items: flex-end;
    }
    .filtro-busca{
        width:80%;
    }
    .filtro-data{
        width: 18%;
    }
    .el-date-editor {
        width: 100%;
        height: 45px;
    }

    .documentosCabecalho{
        margin: 20px;
        width: auto;
        align-items: normal;
        box-sizing: border-box;
        height: 40px;
        border-bottom: 1px solid #E4E7ED;
    }

    .documentosDiv{
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 9px 20px;
        width: 173px;
        height: 40px;
        background: #F5F7FA;
        border: 1px solid #E4E7ED;
        flex: none;
        order: 1;
        flex-grow: 0;
        margin: 0px -1px;
    }

    .divTabelaSelecionada{
        background: #ffffff !important;
    }
    .documentosSpan{
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        align-items: center;
        font-feature-settings: 'tnum' on, 'lnum' on;
        color: #909399;
    }

    .documentosSpanTabelaSelecionada{
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        align-items: center;
        font-feature-settings: 'tnum' on, 'lnum' on;
        color: #00413C;
    }

    .documentosDados{
        margin: 10px 0px 0px 0px;
        width:100%;
        align-items: flex-end;
        box-sizing: border-box;
    }

    .tabelaDados{
        margin: 0px !important;
    }

    .bloco-tabs {
        width: 100%;
        display: flex;
        order: 0;
        padding-right: 12px;
    }

}
</style>
